export default __webpack_public_path__ + "static/media/icon_close.5eb6341a.svg";